import PropTypes from 'prop-types';
import { HighlightLabel } from '../HighlightLabel/HighlightLabel';
import './RadioButton.scss';

export const RadioButton = (props) => {
  const {
    id,
    name,
    value,
    label,
    onChangeHandler,
    smallLabelText,
    highlightLabel,
    isChecked,
    extendClass = '',
    children,
  } = props;
  const classes = ['custom-radio', extendClass].join(' ');

  const handleChange = (event) => {
    if (onChangeHandler) {
      onChangeHandler(event);
    }
  };

  return (
    <div className={classes}>
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={isChecked}
        onChange={handleChange}
        data-testid={`radio-${id}`}
      />
      <label htmlFor={id}>
        {label}
        <br />
        {smallLabelText && (
          <small className="radio-small-label" data-testid="radio-small-label">
            {smallLabelText}
          </small>
        )}

        {highlightLabel && <HighlightLabel>{highlightLabel}</HighlightLabel>}
      </label>

      {children}
    </div>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  onChangeHandler: PropTypes.func,
  smallLabelText: PropTypes.node,
  highlightLabel: PropTypes.string,
  isChecked: PropTypes.bool,
  extendClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
